"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateBillingPlan = class CreateBillingPlan extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "CreateBillingPlan.item");
    }
    getPayload(...args) {
        const [item] = args;
        const result = _.pick(item, [
            'day',
            'max_date'
        ]);
        for (let field of [
            'contracts',
            'rentals',
            'companies',
            'tenants'
        ]) {
            if (_.isArray(item[field])) {
                result[field] = _.map(item[field], 'id');
            }
        }
        return result;
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formName;
    labelAlign;
    item;
    async $$load_item() {
        return {
            day: this.$fn.today(),
            max_date: null,
            contracts: null,
            companies: null,
            rentals: null,
            tenants: null,
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formName', 'labelAlign', 'item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formName: "CreateBillingPlanOptions",
                labelAlign: "right",
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("CreateBillingPlan|Title", "Create Billing Plan"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2186_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeComponent_2190_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async evh_1548630417156826_completed(event, scope) {
        return await this.actions.evh_1548630417156826_completed.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2186 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2186_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2185 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2186,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2185],
        });
        const act_2248226175642056_closeComponent_2188 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2187 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2188,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2187],
        });
        const act_1548630417156826_closeComponent_2190 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1548630417156826_closeComponent_2190_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_completed_2189 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_2190,
            event: "completed",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_completed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_completed_2189],
        });
        const act_1419464017721962_closeComponent_2192 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2191 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_2192,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2191],
        });
        return {
            act_7315092382398562_closeModal_2186,
            evh_7315092382398562_close_2185,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2188,
            evh_2248226175642056_close_2187,
            evh_2248226175642056_close,
            act_1548630417156826_closeComponent_2190,
            evh_1548630417156826_completed_2189,
            evh_1548630417156826_completed,
            act_1419464017721962_closeComponent_2192,
            evh_1419464017721962_clickPreventStop_2191,
            evh_1419464017721962_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], CreateBillingPlan.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateBillingPlan.prototype, "onSize", null);
CreateBillingPlan = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateBillingPlan);
exports.default = CreateBillingPlan;
vue_property_decorator_1.Vue.component("CreateBillingPlan", CreateBillingPlan);
